/* eslint-disable react/prop-types */

import React from "react";

export const Collapse = ({children, handleClick = {}}) => {
    return (
        <div className="collapse" id="filter-collapse">
            <div className="card card-body border-0 py-0 my-0">
                <div className="px-4 py-2 text-start">

                    { children }

                </div>
            </div>
        </div>
    )
}
